import { render, staticRenderFns } from "./ReceiveList_List.vue?vue&type=template&id=adfc257a&"
import script from "./ReceiveList_List.vue?vue&type=script&lang=js&"
export * from "./ReceiveList_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports